import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend'

const defaultLang = process.env.REACT_APP_LANG || 'en';
const isProduction = process.env.REACT_APP_MODE === 'prod';

i18n
  .use(HttpBackend)
  .use(initReactI18next) 
  .init({
    lng: localStorage.getItem('language') || defaultLang,
    debug: false,
    fallbackLng: defaultLang,
    supportedLngs: ["en", "ru", "es"],
    ns: ['translations'],
    backend: {
      loadPath: isProduction
      ? '/locales/{{lng}}/{{ns}}.json'   
      : 'http://localhost:8800/locales/{{lng}}/{{ns}}.json', 
      // loadPath: 'http://192.168.0.112:8800/locales/{{lng}}/{{ns}}.json'
      // loadPath: 'http://192.168.56.1:8800/locales/{{lng}}/{{ns}}.json'
      queryStringParams: { v: '1.2.6' },

    }
  });

export default i18n;
